const state = {
    loadingModule: [],
    logbooks: [],
    logbook_entries: {},
    totals: [],
    recent_acquisitions: [],
    recent_dispositions: [],
    partial_dispositions: [],
    multiple_purchases: [],
    pending_4473: [],
    dbVersion: 1,
    purposeIDs: {},
    cadenceCodes: {},
    stateOfResidenceCodes: {}
}
const mutations = {
    UPDATE_LOADING_MODULE(state, { value, remove }) {
        if (remove) {
            state.loadingModule.splice(state.loadingModule.indexOf(value), 1)
        } else if (state.loadingModule.indexOf(value) == -1) {
            state.loadingModule.push(value)
        }
    },
    UPDATE_STATE(state, obj) {
        for (let prop in state) {
            if (obj.hasOwnProperty(prop) && prop != 'logbooks') {
                state[prop] = obj[prop]
            }
        }
    },
    UPDATE_PROPERTY(state, { property, value }) {
        state[property] = value
    },
    UPDATE_PREFERENCE(state, { preference, value }) {
        state[preference] = value
    }
}
const getters = {
    getLoadingModule: state => state.loadingModule.length > 0,
    getLoadingModuleArray: state => state.loadingModule,
    getLogbooks: state => state.logbooks,
    getTotals: state => state.totals,
    getRecentAcquisitions: state => state.recent_acquisitions,
    getRecentDispositions: state => state.recent_dispositions,
    getPartialDispositions: state => state.partial_dispositions,
    getMultiplePurchases: state => state.multiple_purchases,
    getPending4473: state => state.pending_4473,
    getDbVersion: state => state.dbVersion,
    getEnicsTransactionPurposeIds: state => state.enicsTransactionPurposeIds,
    getEnicsCadenceCodes: state => state.enicsCadenceCodes,
    getEnicsStateOfResidenceCodes: state => state.enicsStateOfResidenceCodes,
    getEnicsCertificateFilename: state => state.enicsCertificateFilename
}
const actions = {
    bootstrapModule({ state, commit, dispatch, rootState }) {
        rootState.source = 'LOGBOOKS'
        if (document.location.pathname.indexOf('customer-4473') > -1) return
        commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive' })
        this.dispatch('fetchModuleNavMenu', 'LOGBOOKS_DASHBOARD_MENU').then(() => {
            commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive', remove: true })
        }).catch(err => {
            commit('UPDATE_LOADING_MODULE', { value: 'get_menu_recursive', remove: true })
            console.log(err);
        })
    },
    updateLoadingModule({ commit }, { value, remove }) {
        commit('UPDATE_LOADING_MODULE', { value, remove })
    },
    updateProperty({ commit }, { property, value }) {
        commit('UPDATE_PROPERTY', { property, value })
    },
    updateState({ commit }, data) {
        commit('UPDATE_STATE', data)
    },
    updatePreference({ commit }, data) {
        commit('UPDATE_PREFERENCE', { preference: data.preference, value: data.value })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
